module.exports = __webpack_public_path__ + "static/media/anthropic_logog.a5db517d.png";